import { Directive, HostListener, ElementRef, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CommonServices } from '../Common/CommonServices';

@Directive({
  selector: '[appCityValidator]',
  standalone: false
})
export class CityValidatorDirective {

  // Allows letters, space, dot and hyphen
  private regex: RegExp = /^[a-zA-Z\s.-]+$/;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private commonServices: CommonServices,
    @Optional() private ngControl: NgControl
  ) {}

  // ✅ Mobile-safe input handling
  @HostListener('input', ['$event'])
  onInput(event: Event) {

    const inputElement = this.el.nativeElement;
    const currentValue = inputElement.value;

    if (currentValue && !this.regex.test(currentValue)) {

      // Remove invalid characters
      const sanitizedValue = currentValue.replace(/[^a-zA-Z\s.-]/g, '');

      // Update DOM
      inputElement.value = sanitizedValue;

      // Sync with Reactive Form
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(sanitizedValue, { emitEvent: false });
      }

      this.commonServices.showMessage(
        'error',
        'City name can contain only letters',
        2
      );
    }
  }

  // ✅ Paste handling
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {

    const clipboardData = event.clipboardData?.getData('text') || '';

    if (!this.regex.test(clipboardData)) {

      event.preventDefault();

      this.commonServices.showMessage(
        'error',
        'Pasted content must contain only letters',
        2
      );
    }
  }
}